export default __webpack_public_path__ + "static/media/PDF.a6e8cc21.svg";